import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 THE 100+ AI PROMPTS FOR FIREFIGHTERS™',
  ideal: 'Career Firefighters, Volunteer Firefighters, Fire Officers, Training Instructors, and Fire Service Professionals who want to organize repetitive documentation and everyday administrative workflows.',
  was: '$174',
  now: '27',
  features: ['Full 6-Volume Fire Service System', '100+ Ready-to-Adapt AI Prompts', 'Compatible with major AI tools, subject to each platform’s availability and terms', '4 Free Professional Bonuses included', '7-Day Money-Back Guarantee', '♾️ Lifetime Access & Free Updates'],
  cta: 'Get the 100+ AI Prompts for Firefighters™ now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Desktop & Mobile'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="relative w-full scroll-mt-14 overflow-hidden bg-charcoal" data-id="element-126" data-mp="4smc0jy9hrvm">
      <div className="mx-auto w-full max-w-5xl px-5 py-14 sm:py-20" style={{
      paddingTop: "25px",
      paddingBottom: "24px"
    }} data-id="element-127" data-mp="9ta1h16ue0nq">
        <div className="mx-auto mb-8 max-w-md text-center" data-id="element-128" data-mp="eqk27czolyqv">
          <p className="font-display text-2xl font-extrabold text-ice" data-id="element-129" data-mp="3d9qoicfsr6t8">🔥 Limited Offer — Ending Soon!</p>
          <p className="mt-2 text-sm font-medium text-steel" data-id="element-130" data-mp="3i93m9s87hyal">
            ⚠️ After this, the price returns to $54. This rate will not come back.
          </p>
          <p className="mt-4 inline-flex rounded-full border border-crimson/40 bg-crimson/10 px-4 py-1.5 text-xs font-bold text-crimson-soft" data-id="element-131" data-mp="3rxv7lhirhkcj">
            🎟️ Only 9 spots left at this price!
          </p>
        </div>

        <div className="relative mx-auto w-full max-w-md" data-id="element-132" data-mp="2zh0zdz4z1lrw">
          <div className="offer-glow pointer-events-none absolute -inset-16" aria-hidden="true" data-id="element-133" data-mp="2zfg427au1ysz" />
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex w-full flex-col items-center overflow-hidden rounded-3xl bg-white text-center text-obsidian shadow-[0_30px_70px_-30px_rgba(0,0,0,0.8)] ring-1 ring-crimson/30" data-id="element-134" data-mp="2res1a5mgyuxe">
            <div className="w-full bg-obsidian px-6 py-4" data-id="element-135" data-mp="23jfjq2b8k67j">
              <h3 className="font-display text-[15px] font-extrabold tracking-wide text-ice sm:text-base" data-id="element-136" data-mp="23l0glyl0w18k">{plan.name}</h3>
            </div>

            <div className="flex w-full flex-col items-center px-6 pb-7 pt-5" data-id="element-137" data-mp="2dgk7u7on6bqz">
              <p className="text-sm leading-relaxed text-graphite" data-id="element-138" data-mp="3tvbppqo5w0m1">
                <span className="font-semibold text-obsidian" data-id="element-139" data-mp="3ttik8epabmfm">Ideal for:</span> {plan.ideal}
              </p>

              <div className="mt-6" data-id="element-140" data-mp="3oycxjdo263qh">
                <span className="text-xl font-semibold text-graphite/70 line-through" data-id="element-141" data-mp="9ucs1fbaji6">{plan.was}</span>
                <div className="flex justify-center py-1" data-id="element-142" data-mp="59qic53nqizu">
                  <span className="relative inline-block font-display leading-none" data-id="element-143" data-mp="573zh9bbgh2b">
                    <span className="absolute right-full top-2 mr-1.5 text-[36px] font-extrabold leading-none text-crimson" style={{
                    color: "#101317"
                  }} data-id="element-144" data-mp="3ngwi4n5q1cbb">$</span>
                    <span className="text-[84px] font-extrabold leading-none tracking-tight text-obsidian" data-id="element-145" data-mp="j1n6xz64aarh">{plan.now}</span>
                  </span>
                </div>
                <p className="mt-2 text-xs font-semibold text-obsidian" data-id="element-146" data-mp="a7i92vskfz2g">· One-time payment · Digital Access ·</p>
                <p className="mt-1 text-[11px] font-medium text-graphite" data-id="element-147" data-mp="e8u0n6v02uda">
                  · Payment will be processed in your local currency, where supported ·
                </p>
              </div>

              <ul className="mt-6 w-full space-y-3 border-t border-mist pt-6 text-left" data-id="element-148" data-mp="16r91uafgi3to">
                {plan.features.map(f => <li key={f} className="flex items-start gap-3 text-sm leading-snug text-obsidian/85" data-id="element-149" data-mp="3f8tnk5f1f0e3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-crimson/10" data-id="element-150" data-mp="3a74darzn2qr2">
                      <CheckIcon className="h-3 w-3 text-crimson" strokeWidth={3.5} aria-hidden="true" data-id="element-151" data-mp="317r0pqg7xm24" />
                    </span>
                    {f}
                  </li>)}
              </ul>

              <div className="mt-7 flex w-full justify-center" data-id="element-152" data-mp="3syx4cgv5e1w5">
                <CTAButton size="md" data-id="element-153" data-mp="3szgmnyopmsap">{plan.cta}</CTAButton>
              </div>

              <p className="mt-3 text-sm font-bold text-crimson-deep" data-id="element-154" data-mp="3o75d04463s4y">Save $147 (84% Off)</p>

              <div className="mt-5 grid w-full grid-cols-2 gap-x-3 gap-y-2.5 border-t border-mist pt-5 text-xs font-medium text-graphite" data-id="element-155" data-mp="3k5k3msqudvzi">
                {trust.map(({
                icon: Icon,
                label
              }) => <span key={label} className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap" data-id="element-156" data-mp="frlmvdysmpu4">
                    <Icon className="h-4 w-4 text-rescue-deep" aria-hidden="true" data-id="element-157" data-mp="1ygzm7ryp0e45" />
                    {label}
                  </span>)}
              </div>
            </div>
          </motion.div>
        </div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-4 rounded-2xl border border-white/10 bg-obsidian/70 p-5 text-left sm:p-6" data-id="element-158" data-mp="27hxs6fsoyvpd">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-crimson/10 ring-1 ring-crimson/25" data-id="element-159" data-mp="2hesnkpto4fzf">
            <ShieldCheckIcon className="h-5 w-5 text-crimson" aria-hidden="true" data-id="element-160" data-mp="2mbj57hl4fjmy" />
          </span>
          <p className="text-[15px] leading-relaxed text-steel" data-id="element-161" data-mp="2r4c7lyt4afvv">
            <span className="font-display font-extrabold text-ice" data-id="element-162" data-mp="2v5nonfxxdssg">🛡️ 7-Day Money-Back Guarantee.</span>{' '}
            If within the first 7 days you decide this system isn't right for you, contact us to
            request a refund under the terms of our guarantee.
          </p>
        </div>
      </div>
    </section>;
}